// extracted by mini-css-extract-plugin
export default {"container":"NoOrganizations_container__mDSBa","card":"NoOrganizations_card__xamWD","title":"NoOrganizations_title__AIm3l","body":"NoOrganizations_body__6qG94"};